<template>
    <header id="header">
        
        <slot name="headerBrandLeft"></slot>
        
        <slot name="headerBrand">
            <div class="brand">
                <router-link tag="a" to="/" class="logo" v-html="$store.state.site.appName"></router-link>
            </div>
        </slot>
        
        <ul class="nav navbar-nav navbar-left">
            <slot name="headerSidebarToggle">
                <li v-if="$store.getters.showSideNavBar" class="toggle-navigation toggle-left">
                    <button class="sidebar-toggle" id="toggle-left" v-on:click="navToggleLeft">
                        <i class="fa fa-bars"></i>
                    </button>
                </li>
            </slot>
        
            <slot name="headerLeft"></slot>
        </ul>
        
        <slot name="headerCenter"></slot>
        
        <!-- RIGHT  MENU -->
        <ul class="nav navbar-nav navbar-right pull-right">
        
        <slot name="headerRight"></slot>
        
        <slot  v-if="$store.state.auth.authenticated"  tag="li" name="logout" class="">
            <button  @click="onLogOut()"  class="sidebar-toggle" style="width: auto;">
                <i class="fa fa-sign-out"></i>
                <span class="hidden-xs">Logout</span>
            </button>
        </slot>
    </ul>

    </header>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        name: 'app-header',
        data() {
            return {
                showLogo: true
            }
        },
        methods: {
            onLogOut() {
                this.$store.dispatch('LOGOUT');
                this.$router.push('/login')
            },
            
            navToggleLeft(){
                 ($(window).width() > 767) ? this.$store.commit('SET_SIDEBARMINI', !this.$store.state.site.sidebarMini ) : this.$store.commit('SET_SIDEBAROPEN', !this.$store.state.site.sidebarOpen );
            }

        }
    }
</script>

<style>


#header button#toggle-profile.logout {
     width: 160px; 

}

</style>
